import { Loader2 } from "lucide-react";

import { Folder, MediaSchema, SpotInfoDisplaySchema } from './SpotSchema';
import { SpotSchema } from './SpotSchema';
import { Button } from "@/components/ui/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel
} from "@/components/ui/form"
import { Input } from "@/components/ui/input";
import { set, z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm, useWatch } from "react-hook-form";
import { TextArea } from '../ui/textarea';
import { useEffect, useRef, useState } from 'react';
import { Popup } from "../common/Popup";
import { Templates } from "./Templates";
import { TemplateEditor } from "./TemplateEditor";
import { SpotPreview } from "./SpotPreview";
import { useApiFetch } from "@/helper/apiFetch";
import { useTranslate } from '@/helper/translate';
import { Upload, Download, LayoutTemplate, HardDrive, Database } from 'lucide-react';
import { SVGEditor, TemplateHandle } from './SVGEditor';
import React from 'react';
import { blobToDataURL } from '@/helper/sort';
import { useAuth } from "@/auth";
import { FolderComp } from "./Folder";
type SpotInfoProps = {
  spotId: string | null;
  customerId: string;
  orderId: string|null;
  onClose: () => void;
  onChanged: (spot: SpotInfoDisplaySchema | null) => void;
};

export function SpotInfo({ spotId, customerId, orderId, onClose, onChanged }: SpotInfoProps) {
console.log("SpotInfo rendered with spotId:", spotId, "customerId:", customerId, "orderId:", orderId);

  const apiFetch = useApiFetch();
  const { translate } = useTranslate();
  const { linkedCustomerId } = useAuth();
  var returnValue: SpotInfoDisplaySchema | null = null;
  const [showTemplateList, setShowTemplateList] = useState(false);

  const [showPopupRedlof, setPopupRedlof] = useState(false);
  const [showPopup, setPopup] = useState(false);
  const [mediaIndex, setIndex] = useState(0);
  const [isSaving, setIsSaving] = useState(false);
  const [isFirstFile, setIsFirstFile] = useState(false);
  const [isLoadingRM, setIsLoadingRM] = useState(false);

  const [fileSelectionList, setFileSelection] = useState<Folder[] | null>(null);
  const [expandedList, setExpandedList] = useState<string[] | null>(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isPreview, setPreview] = useState(false);
  const [isUndo, setUndo] = useState(false);
  const [isChanged, setChanged] = useState(spotId == null || spotId == "");
  const [errorText, setError] = useState("");
  const [warningText, setWarning] = useState("");
  const [popupError, setPopupError] = useState("");
  const [orders, setOrders] = useState<{ orderId: string, orderName: string, aspectRatios: string[] }[]>([]);
  const form = useForm<z.infer<typeof SpotSchema>>({
    resolver: zodResolver(SpotSchema),
    defaultValues: {}
  });

  // const mediaFiles = form.watch("tbMediaFiles"); // subscribes to the array so it redraws after upload

  const fileInputRef = useRef<HTMLInputElement>(null);
  const editorRef = useRef<TemplateHandle>(null);

  const selectFile = async (redlof: boolean | null) => {

    if (redlof == null) {
      if (linkedCustomerId != "Admin")
        fileInputRef.current?.click();
      else setPopupRedlof(true);
    }
    else if (redlof == false)
      fileInputRef.current?.click();
    else {
      setIsLoadingRM(true);

      const res = await apiFetch(`/App/GetSpotSelection?customerId=${customerId}`, {
        method: "GET",

      });
      setIsLoadingRM(false);

      if (!res.ok) {
        const e = await res.text();
        setError("Failed to get spots: " + e);

      }
      else {
        const files = await res.json();
        console.log(files);
        setFileSelection(files as Folder[]);



      }

    }
  };

  function Cancel() {
    onClose();
  }
  function checkAspectRatio(
    expected: string,         // e.g. "16:9" or "16x9"
    width: number,
    height: number,
    tolerance = 0.01          // 1% tolerance; tweak as needed
  ): boolean {
    const [wStr, hStr] = expected.replace("x", ":").split(":");
    const wExp = Number(wStr), hExp = Number(hStr);
    if (!wExp || !hExp || !width || !height) return false;

    const actual = width / height;
    const target = wExp / hExp;
    return Math.abs(actual - target) <= target * tolerance;
  }



  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    setError("");
    const file = e.target.files?.[0];
    if (!file) return;
    e.target.value = "";

    if (file.size > 20 * 1024 * 1024) {
      setError(translate("ui.fileTooLarge"));
      return;
    }

    if (file.size > 10 * 1024 * 1024) {
      setWarning(translate("ui.fileWarning"));
    }


    const fd = new FormData();
    fd.append("file", file);

    const res = await apiFetch(`/App/PrepareSpot?type=Local&spotId=${form.getValues('spotId')}&customerId=${customerId}&orderId=${orderId}&aspectRatio=${isFirstFile ? "" : form.getValues(`tbMediaFiles.${mediaIndex}.aspectRatio`)}`, { method: "POST", body: fd });

    if (res.ok) {
      var data = await res.json();
      const media = MediaSchema.parse(data.media);
      var indexUsed = mediaIndex;
      if (isFirstFile)//find mediaindex
      {
        let found = false;
        //loop through media files to find matching aspect ratio
        for (var i = 0; i < (form.getValues("tbMediaFiles") ?? []).length; i++) {
          if (form.getValues(`tbMediaFiles.${i}.aspectRatio`) == media.aspectRatio) {
            setIndex(i);
            indexUsed = i;
            found = true;
            break;
          }
        }
        if (!found)//no match, add new media file
        {
          var error = translate("ui.nomediaforaspectratio") + media.aspectRatio;
          setPopupError(error);
          return;
        }

        setIsFirstFile(false);


      }

      media.mediaFileId = form.getValues(`tbMediaFiles.${indexUsed}.mediaFileId`);
      form.setValue(`tbMediaFiles.${indexUsed}`, media, { shouldDirty: true, shouldTouch: true });
      if (form.getValues("spotName") == null || form.getValues("spotName") === "")
        form.setValue("spotName", file.name.substring(0, file.name.lastIndexOf(".")));
      await setSource(media, indexUsed);

      if(data.warnings != "")
        setWarning(data.warnings);
    }
    else {


      var error = await res.text();
      setPopupError(error);
      return;

    }
    setPopup(false);
    setPopupRedlof(false);
    // setSource(file);
    /* const url = URL.createObjectURL(file);
     const allowedAspectRatios = form.getValues(`tbMediaFiles.${mediaIndex}.aspectRatio`)?.toString() as string;
 
 
     if (file.type.startsWith("video/")) {
       const video = document.createElement("video");
       //const video = document.getElementById("video") as HTMLVideoElement;
 
 
       video.preload = "metadata";
 
       video.onloadedmetadata = () => {
         //check aspect ratio first
         if (!checkAspectRatio(allowedAspectRatios, video.videoWidth, video.videoHeight)) {
           setError("Invalid aspect ratio, expected " + allowedAspectRatios);
           URL.revokeObjectURL(url);
 
           return;
         }
 
         if (video.duration > 30) {
           setError("Video is too long");
           URL.revokeObjectURL(url);
 
           return;
         }
         // // //valid:
         //override filename with index (new File)
         //match by aspectRatio==filename
         fileMapRef.current.set(String(aspectRatio), new File([file], String(aspectRatio), { type: file.type, lastModified: file.lastModified })); // replaces any existing
         if (form.getValues("spotName") == null || form.getValues("spotName") === "")
           form.setValue("spotName", file.name.substring(0, file.name.lastIndexOf(".")));
 
 
         form.setValue(`tbMediaFiles.${mediaIndex}.mimeType`, file.type);
         form.setValue(`tbMediaFiles.${mediaIndex}.formatConverted`, file.name.split('.').pop() || "");
         //use this field for the filename
         form.setValue(`tbMediaFiles.${mediaIndex}.pathServer`, file.name);
         form.setValue(`tbMediaFiles.${mediaIndex}.size`, file.size);
         form.setValue(`tbMediaFiles.${mediaIndex}.length`, video.duration);
         form.setValue(`tbMediaFiles.${mediaIndex}.width`, video.videoWidth);
         form.setValue(`tbMediaFiles.${mediaIndex}.height`, video.videoHeight);
         form.setValue(`tbMediaFiles.${mediaIndex}.fileData`, url);
         form.setValue(`templateId`, null);
         form.setValue("statusId", 1);
         setChanged(true);
         setPopup(false);
 
       };
 
       video.src = url;
     }
     else {
       const img = new Image();
       //const img = document.getElementById("image") as HTMLImageElement;
       img.onload = () => {
 
         //throws error if aspect ratio is not valid
         if (!checkAspectRatio(allowedAspectRatios, img.width, img.height)) {
           setError("Invalid aspect ratio, expected " + allowedAspectRatios);
           URL.revokeObjectURL(url);
 
           return;
         }
 
 
 
         // // //valid:
         //override filename with index (new File)
         //match by mediaIndex==filename
         fileMapRef.current.set(String(aspectRatio), new File([file], String(aspectRatio), { type: file.type, lastModified: file.lastModified })); // replaces any existing
         if (form.getValues("spotName") == null || form.getValues("spotName") === "")
           form.setValue("spotName", file.name.substring(0, file.name.lastIndexOf(".")));
         form.setValue(`tbMediaFiles.${mediaIndex}.mimeType`, file.type);
         form.setValue(`tbMediaFiles.${mediaIndex}.size`, file.size);
         form.setValue(`tbMediaFiles.${mediaIndex}.fileData`, url);
         form.setValue(`tbMediaFiles.${mediaIndex}.formatConverted`, file.name.split('.').pop() || "");
         //use this field for the filename
         form.setValue(`tbMediaFiles.${mediaIndex}.pathServer`, file.name);
         form.setValue(`tbMediaFiles.${mediaIndex}.width`, img.width);
         form.setValue(`tbMediaFiles.${mediaIndex}.height`, img.height);
 
         form.setValue(`templateId`, null);
         form.setValue("statusId", 1);
         setChanged(true);
 
         setPopup(false);
 
 
       };
 
       img.src = url;
     }
 
 */

  };

  // const setSourceOld = (file: File | Blob) => {
  //   const allowedAspectRatios = form.getValues(`tbMediaFiles.${mediaIndex}.aspectRatio`)?.toString() as string;
  //   const url = URL.createObjectURL(file);


  //   if (file.type.startsWith("video/")) {
  //     const video = document.createElement("video");
  //     //const video = document.getElementById("video") as HTMLVideoElement;


  //     video.preload = "metadata";

  //     video.onloadedmetadata = () => {
  //       //check aspect ratio first
  //       if (!checkAspectRatio(allowedAspectRatios, video.videoWidth, video.videoHeight)) {
  //         setError("Invalid aspect ratio, expected " + allowedAspectRatios);
  //         URL.revokeObjectURL(url);

  //         return;
  //       }

  //       if (video.duration > 30) {
  //         setError("Video is too long");
  //         URL.revokeObjectURL(url);

  //         return;
  //       }
  //       // // //valid:
  //       //override filename with index (new File)
  //       //match by aspectRatio==filename
  //       if (file instanceof File) {
  //         fileMapRef.current.set(String(aspectRatio), new File([file], String(aspectRatio), { type: file.type, lastModified: file.lastModified })); // replaces any existing
  //         form.setValue(`tbMediaFiles.${mediaIndex}.pathServer`, file.name);
  //         if (form.getValues("spotName") == null || form.getValues("spotName") === "")
  //           form.setValue("spotName", file.name.substring(0, file.name.lastIndexOf(".")));
  //       }
  //       else//to make sure it draws on screen but we don't want to send to server.
  //         fileMapRef.current.set(String(aspectRatio), new File([], String(aspectRatio), { type: file.type })); // replaces any existing

  //       form.setValue(`tbMediaFiles.${mediaIndex}.mimeType`, file.type);
  //       //form.setValue(`tbMediaFiles.${mediaIndex}.formatConverted`, file.name.split('.').pop() || "");
  //       form.setValue(`tbMediaFiles.${mediaIndex}.size`, file.size);
  //       form.setValue(`tbMediaFiles.${mediaIndex}.length`, video.duration);
  //       form.setValue(`tbMediaFiles.${mediaIndex}.width`, video.videoWidth);
  //       form.setValue(`tbMediaFiles.${mediaIndex}.height`, video.videoHeight);
  //       form.setValue(`tbMediaFiles.${mediaIndex}.fileData`, url);
  //       form.setValue(`templateId`, null);
  //       form.setValue("statusId", 1);
  //       setChanged(true);
  //       setPopup(false);

  //     };

  //     video.src = url;
  //   }
  //   else {
  //     const img = new Image();
  //     //const img = document.getElementById("image") as HTMLImageElement;
  //     img.onload = () => {

  //       //throws error if aspect ratio is not valid
  //       if (!checkAspectRatio(allowedAspectRatios, img.width, img.height)) {
  //         setError("Invalid aspect ratio, expected " + allowedAspectRatios);
  //         URL.revokeObjectURL(url);

  //         return;
  //       }



  //       // // //valid:
  //       //override filename with index (new File)
  //       //match by mediaIndex==filename
  //       if (file instanceof File) {
  //         fileMapRef.current.set(String(aspectRatio), new File([file], String(aspectRatio), { type: file.type, lastModified: file.lastModified })); // replaces any existing
  //         form.setValue(`tbMediaFiles.${mediaIndex}.pathServer`, file.name);
  //         if (form.getValues("spotName") == null || form.getValues("spotName") === "")
  //           form.setValue("spotName", file.name.substring(0, file.name.lastIndexOf(".")));
  //       }
  //       form.setValue(`tbMediaFiles.${mediaIndex}.mimeType`, file.type);
  //       form.setValue(`tbMediaFiles.${mediaIndex}.size`, file.size);
  //       form.setValue(`tbMediaFiles.${mediaIndex}.fileData`, url);
  //       // form.setValue(`tbMediaFiles.${mediandex}.formatConverted`, file.name.split('.').pop() || "");
  //       //use this field for the filename
  //       form.setValue(`tbMediaFiles.${mediaIndex}.width`, img.width);
  //       form.setValue(`tbMediaFiles.${mediaIndex}.height`, img.height);

  //       form.setValue(`templateId`, null);
  //       form.setValue("statusId", 1);
  //       setChanged(true);

  //       setPopup(false);


  //     };

  //     img.src = url;
  //   }

  // }



  const setSource = async (media: z.infer<typeof MediaSchema>, index: number) => {

    try {
      const res = await apiFetch(`/App/ServeImage?path=${encodeURIComponent(media.pathServer && media.mimeType?.startsWith("image") ? media.pathServer as string : media.snapshotPath as string)}`);
      if (!res.ok) throw new Error("Failed to fetch image");
      const url = await blobToDataURL(await res.blob());
      form.setValue(`tbMediaFiles.${index}.fileData`, url, { shouldDirty: true, shouldTouch: true });



    } catch (e) {
      console.error(e);
    }

  }


  const setSpotStatus = async (statusId: number) => {

    const res = await apiFetch(`/App/SetSpotStatus?spotId=${spotId}&statusId=${statusId}`, {
      method: "GET",

    });

    if (!res.ok) {
      const e = await res.text();
      setError("Request failed: " + e);

    }
    else {
      setError("");
      form.setValue('statusId', statusId, { shouldDirty: true, shouldTouch: true, shouldValidate: true });
      //create a spotinfoDisplaySchema to return with updated status without refetching
      const displaySchema = {
        id: form.getValues("spotId") as string,
        name: form.getValues("spotName") as string,
        note: form.getValues("note") as string,
        category: "",
        isAutoGenerated: false,
        statusId: statusId,
        isSelected: false,
        isDeleted: false,
        mediaFile: null,
        error: "",
        statusDescription: statusId == 3 ? "Approved" : statusId == 4 ? "Denied" : statusId == 1 ? "Editing" : "AwaitingApproval"
      };
      onChanged(displaySchema as SpotInfoDisplaySchema);

    }




  }
  const sourceClicked = () => {
    if (statusId != 1)
      return;

    var templateId = form.getValues(`templateId`);
    if (templateId == null || templateId == "")
      selectFile(null);
    // else
    //  setTemplateEditor(templateId as string);
  }
  const updateStatus = (statusId: number, comment: string | null) => {

    //form.setValue("statusDescription", statusId == 3 ? "Approved" : statusId == 4 ? "Denied" : "Unknown");
    form.setValue("comment", comment);
    form.setValue('statusId', statusId, { shouldDirty: true, shouldTouch: true, shouldValidate: true });
  }

  const download = async (mediaIndex: number) => {

    const res = await apiFetch(`/App/ServeMedia/${form.getValues(`tbMediaFiles.${mediaIndex}.mediaFileId`)}`)


    if (!res.ok) {
      const text = await res.text().catch(() => "");
      throw new Error(`Download failed ${res.status}: ${text}`);
    }

    // Try to get a filename from Content-Disposition
    const dispo = res.headers.get("content-disposition") || "";
    const match = dispo.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
    const suggestedName = decodeURIComponent(form.getValues("spotName") ?? "file");

    const blob = await res.blob();
    const blobUrl = URL.createObjectURL(blob);

    // Create a temporary link and click it
    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = suggestedName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(blobUrl);


  }
  const onSubmit = async (values: z.infer<typeof SpotSchema>) => {
    try {
      setIsSaving(true);

      setError("");
      if (editorRef.current != null) {


        editorRef.current?.Save().then(templateId => {
          if (templateId.startsWith("error")) {
            setIsSaving(false);
            setError(templateId.substring(5));
            return;
          }
          values.templateId = templateId;
          Save(values);

        }
        );
      }
      else {
        //we need every format (makes no sense to me but it's requested by benni)
        if (!form.getValues('templateId')) {
          for (const mf of form.getValues("tbMediaFiles") ?? []) {
            if (mf.fileData == null) {
              setError(translate("ui.allMediaFilesNeedUpload"));
              setIsSaving(false);

              return; // exits the parent function
            }
          }
        }


        Save(values);
      }

    } catch (err) {
      console.error(err);
    }
  }


  const Save = async (values: z.infer<typeof SpotSchema>) => {
    try {


      const fd = new FormData();
      //dont send fileURLs
      const payload = {
        ...values,
        tbMediaFiles: values.tbMediaFiles?.map(({ fileData, ...rest }) => rest),
      };

      fd.append("payload", JSON.stringify(payload));

      // for (const [name, f] of fileMapRef.current) {
      //   fd.append("files[]", f, name); // server can read f.name 
      // }
console.log("save spot:");
      const res = await apiFetch(`/App/SaveSpot`, { method: "POST", body: fd });

      setIsSaving(false);
      if (!res.ok) {
        console.error("Save failed", await res.text());
        const e = await res.text();
        setError(translate("ui.failedsave") + e);

      }
      else {
        const data = await res.json();
        onChanged(data as SpotInfoDisplaySchema);
        // if (isChanged) {
        //   setChanged(false);
        //   setSpotID(data.id);
        //   fileMapRef.current.clear();
        //   returnValue = data;
        // }
        // else

          if(data.warnings && data.warnings != "")
          {
            setWarning(data.warnings);
          }
          else
          {
            console.log("Spot closing");
            onClose();
          }

      }
    } catch (err) {
      console.error(err);
      setIsSaving(false);
    }
  }


  const statusId = form.watch("statusId");

  useEffect(() => {




    apiFetch(`/App/GetSpot?spotId=${spotId}&customerId=${customerId}`)
      .then(res => {
        if (!res.ok) throw new Error("Failed to fetch");
        return res.json();
      })
      .then(data => {

        //we need fileData property
        data.spot.tbMediaFiles.forEach((mf: any) => {
          mf.fileData = null;

        });
        form.reset(data.spot);
        setOrders(data.orders);

        if (spotId == null || spotId == "") {
          setIsLoaded(true);
          setPopup(true);
          setIsFirstFile(true);//media format is NOT determined.
        }
        else {
          //load snapshots for media files
          data.spot.tbMediaFiles.forEach(async (mf: any, index: number) => {
            if (mf.aspectRatio == "16x9")
              setIndex(index);//default to 16x9 for new spot, SHOULD be 0 but can't guarantee order

            if (mf.snapshotPath && !mf.fileData) {
              try {
                // const res = await apiFetch(`/App/ServeImage?path=${encodeURIComponent(mf.snapshotPath)}`);
                // if (!res.ok) throw new Error("Failed to fetch image");
                // const url = await blobToDataURL(await res.blob());
                // form.setValue(`tbMediaFiles.${index}.fileData`, url, { shouldDirty: true, shouldTouch: true });

                await setSource(mf, index);
                //set after first is laoded
                setIsLoaded(true);

              } catch (e) {
                console.error(e);
              }
            }
          });
        }

      })
      .catch(err => {
        console.error(err);

      });
  }, []);

  const aspectRatio = form.getValues(`tbMediaFiles.${mediaIndex}.aspectRatio`) ?? "";
  //const fileData = useWatch({ control: form.control, name: `tbMediaFiles.${mediaIndex}.fileData` });
  //const snapshot = useWatch({ control: form.control, name: `tbMediaFiles.${mediaIndex}.snapshotPath` });
  return (

    <div className="popCnt p-0">
      {!isLoaded ? (
        <div className="w-full text-center my-10">{translate("common.loading")}</div>
      ) : (
        <div>
          <input
            type="file"
            accept=".png, .jpg, .jpeg, .tiff, .bmp, .wmv, .mp4, .m4v"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
          {!showPopup && (
            <Form {...form}>

              <div className="space-y-2">

              <div className="bg-white dark:bg-zinc-600 rounded-2xl shadow-lg space-y-4 mx-[-10px] my-1 px-3 py-4">


                <div className="grid gap-2 grid-cols-3">
                  <FormField
                    control={form.control}
                    name="spotName"
                    render={({ field }) => (
                      <FormItem className="col-span-2">
                        <FormLabel>{translate("ui.name")}</FormLabel>
                        <FormControl>
                          <Input {...field} />
                        </FormControl>
                      </FormItem>
                    )}
                  />




                  <div>
                    {spotId && (
                      statusId === 1 ? (
                        <div className="ml-6 text-sm font-medium">
                          <span className="absolute top-0 right-[5rem] spotStatus1 px-5 py-3 rounded-b-md shadow-sm shadow-gray-400 text-base">
                            {translate("ui.status_" + form.getValues("statusId"))}
                          </span>
                          <Button
                            className="mt-[29px] px-6"
                            type="button"
                            variant="outline"
                            onClick={async () => await setSpotStatus(2)}
                          >
                            {translate("ui.submitForApproval")}
                          </Button>
                        </div>
                      ) : statusId === 4 ? (
                        (form.getValues("comment")?.length ?? 0) > 0 ? (
                          <div className="ml-6 text-sm font-medium">
                            <span className="absolute top-0 right-[5rem] spotStatus4 px-5 py-3 rounded-b-md shadow-sm shadow-gray-400 text-base">
                              {translate("ui.status_" + form.getValues("statusId"))}
                            </span>
                            <Button
                              className="mt-[29px] px-6"
                              type="button"
                              variant="outline"
                              onClick={() => setUndo(true)}
                            >
                              {translate("ui.undoApproval")}
                            </Button>
                            <br />
                            <span>{form.getValues("comment")}</span>
                          </div>
                        ) : (
                          <div className="ml-6 text-sm font-medium">
                            <span className="absolute top-0 right-[5rem] spotStatus4 px-5 py-3 rounded-b-md shadow-sm shadow-gray-400 text-base">
                              {translate("ui.status_" + form.getValues("statusId"))}
                            </span>
                            <Button
                              className="mt-[29px] px-6"
                              type="button"
                              variant="outline"
                              onClick={() => setUndo(true)}
                            >
                              {translate("ui.undoApproval")}
                            </Button>
                          </div>
                        )
                      ) : statusId === 2 ? (
                        <div className="ml-6 text-sm font-medium">
                          <span className="absolute top-0 right-[5rem] spotStatus2 px-5 py-3 rounded-b-md shadow-sm shadow-gray-400 text-base">
                            {translate("ui.status_" + form.getValues("statusId"))}
                          </span>
                          <Button
                            className="mt-[29px] px-6"
                            type="button"
                            variant="outline"
                            onClick={() => setUndo(true)}
                          >
                            {translate("ui.undoApproval")}
                          </Button>
                        </div>
                      ) : statusId === 3 ? (
                        <div className="ml-6 text-sm font-medium">
                          <span className="absolute top-0 right-[5rem] spotStatus3 px-5 py-3 rounded-b-md shadow-sm shadow-gray-400 text-base">
                            {(form.getValues("tbBookings") ?? []).length > 0 ? translate("ui.status_active") : translate("ui.status_" + form.getValues("statusId"))}
                          </span>
                          <Button
                            className="mt-[29px] px-6"
                            type="button"
                            variant="outline"
                            onClick={() => setUndo(true)}
                          >
                            {translate("ui.undoApproval")}
                          </Button>
                        </div>
                      ) : null
                    )}
                  </div>




                  <FormField
                    control={form.control}
                    name="note"
                    render={({ field }) => (
                      <FormItem className="col-span-3 note">
                        <FormLabel>{translate("ui.note")}</FormLabel>
                        <FormControl>
                          <TextArea {...field} />
                        </FormControl>
                      </FormItem>
                    )}
                  />

                </div>



                <div className="!mt-0">

                  <div className="tabs">
                    {!form.getValues('templateId') && form.getValues('tbMediaFiles')?.map((media, index) => (
                      <span
                        key={index}
                        className={`tab ${index === mediaIndex ? 'active' : ''}`}
                        onClick={() => setIndex(index)}
                      >
                        {translate("ui.format")} {media.aspectRatio ? media.aspectRatio : "N/A"}
                      </span>
                    ))}
                  </div>

                  <div >




                    {form.getValues(`templateId`) ? (
                      <div className="grid-default" key={mediaIndex}>
                        <SVGEditor
                          ref={editorRef}
                          templateId={form.getValues(`templateId`) as string}
                          customerId={customerId}
                          //aspectRatio={form.getValues(`tbMediaFiles.${mediaIndex}.aspectRatio`) as string} 
                          onChanged={() => {
                            setChanged(true);
                            form.setValue("statusId", 1);
                          }}>
                        </SVGEditor>
                      </div>

                    ) : (

                      <div className="grid-default" key={mediaIndex}>
                       {(form.getValues("tbMediaFiles") ?? []).length > 1 && (
                          <div className="col-span-2">
                            {translate("ui.neededForOrders")}: <br />
                           {[...new Set(
                            (orders ?? [])
                              .filter(o => o.aspectRatios?.includes(aspectRatio))
                              .map(o => o.orderName)
                          )].join(", ")}
                          </div>
                        )} 
                        <div onClick={() => sourceClicked()} className={` ${(statusId == 1) ? 'cursor-pointer' : 'cursor-not-allowed'}`}>
                          {
                            (form.getValues(`tbMediaFiles.${mediaIndex}.fileData`) == null) ? (
                              <div>
                                <Button type="button" variant="outline" className="w-full h-[150px]">
                                  {translate("ui.selectFile")}
                                </Button>
                              </div>
                            ) : (

                              // form.getValues(`tbMediaFiles.${mediaIndex}.mimeType`)?.startsWith("video") && fileMapRef.current.get(String(form.getValues(`tbMediaFiles.${mediaIndex}.aspectRatio`))) ? (
                              //   <video
                              //     className="w-full "

                              //     src={form.getValues(`tbMediaFiles.${mediaIndex}.fileData`) ?? undefined}
                              //   />) : (
                              //   <video
                              //     className="w-full "

                              //     src={fileURL != null ? fileURL : `data:video/x-ms-wmv;base64,${form.getValues(`tbMediaFiles.${mediaIndex}.snapshot`)}`}
                              //   //src={`${API_BASE_URL}/App/ServeMedia?mediaFileId=${`tbMediaFiles.${mediaIndex}.mediaFileId`}`}
                              //   />) : (
                              //   <img
                              //     className="w-full  "
                              //     src={fileURL != null ? fileURL : `data:image/png;base64,${form.getValues(`tbMediaFiles.${mediaIndex}.snapshot`)}`}
                              //   />
                              // )
                              <img
                                className="w-full  "
                                src={form.getValues(`tbMediaFiles.${mediaIndex}.fileData`) ?? undefined}// `data:image/png;base64,${snapshot}`}
                              />
                              //)
                            )}


                        </div>
                        <div className="p-2">

                          <div className='grid-default mt-2'>
                            <FormField
                              control={form.control}
                              name={`tbMediaFiles.${mediaIndex}.mimeType`}
                              render={({ field }) => (
                                <FormItem >
                                  <FormLabel>{translate("ui.type")}</FormLabel>
                                  <FormControl>
                                    <Input {...field} disabled />
                                  </FormControl>
                                </FormItem>
                              )}
                            />
                            <FormField
                              control={form.control}
                              name={`tbMediaFiles.${mediaIndex}.length`}
                              render={({ field }) => (
                                <FormItem>
                                  <FormLabel>{translate("ui.duration")}</FormLabel>
                                  <FormControl>
                                    <Input {...field} disabled />
                                  </FormControl>
                                </FormItem>
                              )}
                            />
                            {!isChanged && (
                              <Download size={32} className='cursor-pointer bg-sky-600 hover:bg-sky-700 dark:bg-orange-400 dark:hover:bg-orange-500 rounded-full p-[6px] text-white' aria-labelledby="dlTitle" onClick={() => download(mediaIndex)}>
                                <title id="dlTitle">Download</title>
                              </Download>
                            )}
                          </div>
                        </div>
                      </div>

                    )}



                  </div>


                </div>

                {warningText && (
                  <div className="text-red-500 mt-2 " style={{ whiteSpace: "pre-line" }}>
                    {warningText}
                  </div>
                )}
              </div>

                <div className="grid-default">
                  <div className="grid-default">{!isChanged && (

                    <Button className="w-full" type="button" onClick={() => { setPreview(true); }}>{translate("common.preview")}</Button>


                  )}</div>

                  <div className="grid-default">

                    <Button className="w-full" type="button" onClick={() => { console.log("Cancel clicked"); onClose(); }}>{translate("common.cancel")}</Button>
                    {form.getValues("statusId") == 2 ? null : (//don't let changes be made, we need the UOM to stay for approval email
                      // <Button className="w-full" type="submit">{isChanged ? translate("common.generate") : translate("common.save")}</Button>
                      <Button className="w-full" type="button" onClick={() => form.handleSubmit(onSubmit, (errors) => console.log("Validation errors:", errors))()}>
                        {isSaving && <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />}
                        {translate("common.save")}
                      </Button>
                    )}
                  </div>
                </div>

              </div>
            </Form>

          )}
        </div>
      )}


      <Popup
        isOpen={showPopup}
        onClose={() => setPopup(false)}
        title={translate("ui.choose")}
        className="w-[800px]"
      >
        <div className="grid-default tmpl1">

          <Button type="button" variant="outline" className="w-full h-[150px] flex flex-col" onClick={() => { selectFile(null); }}>
            <Upload className="!w-[40px] !h-[40px]" strokeWidth={1.25} />
            {translate("ui.uploadFile")}
          </Button>
          <Button type="button" variant="outline" className="w-full h-[150px] flex flex-col" onClick={() => { setShowTemplateList(true); }}>
            <LayoutTemplate className="!w-[40px] !h-[40px]" strokeWidth={1.25} />
            {translate("ui.selectTemplate")}
          </Button>
        </div>
      </Popup>

      <Popup
        isOpen={showPopupRedlof}
        onClose={() => setPopupRedlof(false)}
        title={translate("ui.choose")}
        className="w-[800px]"
      >
        <div className="grid-default tmpl2">
          <Button type="button" variant="outline" className="w-full h-[150px] flex flex-col" onClick={() => { selectFile(false); }}>
            <HardDrive className="!w-[40px] !h-[40px]" strokeWidth={1.25} />
            Lokal (upload)
          </Button>
          <Button type="button" variant="outline" className="w-full h-[150px] flex flex-col" onClick={() => { selectFile(true); }}>
            <Database className="!w-[40px] !h-[40px]" strokeWidth={1.25} />
            {isLoadingRM && <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />}
            RMServer02 (select)
          </Button>
        </div>
      </Popup>



      <Popup
        isOpen={isUndo}
        onClose={() => setUndo(false)}
        title={translate("ui.undoApproval")}
        className="w-[800px]"
      >
        <div className="">
          <div>{translate("ui.undoApprovalText")}</div>
          <br />
          <Button type="button" variant="outline" className="" onClick={() => { setSpotStatus(1); setUndo(false); }}>
            {translate("ui.undoApproval")}
          </Button>
          <Button type="button" variant="outline" className="ml-2" onClick={() => { setUndo(false); }}>
            {translate("common.cancel")}
          </Button>
        </div>
      </Popup>





      <Popup
        isOpen={errorText != ""}
        onClose={() => setError("")}
        title={translate("ui.error")}
        className=""
      >
        <div>{errorText}</div>
      </Popup>


      <Popup
        isOpen={showTemplateList}
        onClose={() => setShowTemplateList(false)}
        title={translate("ui.templates")}
        className="w-[80%]"
      >
        <Templates onClose={(templateId: string | null) => { setShowTemplateList(false); setPopup(templateId == null || templateId == ""); form.setValue('templateId', templateId); }} customerId={customerId} format={form.getValues(`tbMediaFiles.${mediaIndex}.aspectRatio`)?.toString() as string}></Templates>
      </Popup>

      <Popup
        isOpen={fileSelectionList != null}
        onClose={() => setFileSelection(null)}
        title="Select File"
        className="w-[80%] max-h-[80vh] overflow-y-auto"
      >
        <div>
          {fileSelectionList?.map((file, index) => (
            <FolderComp
              key={index}
              source={file}
              expandedList={expandedList}
              onChange={async (value: string | number, file: string | null) => {
                if (file != null) {
                  //set selected file

                  try {

                    const res = await apiFetch(`/App/PrepareSpot?type=RM&spotId=${form.getValues('spotId')}&customerId=${customerId}&aspectRatio=${isFirstFile ? "" : form.getValues(`tbMediaFiles.${mediaIndex}.aspectRatio`)}&path=${encodeURIComponent("root\\projekte\\" + file as string)}`, { method: "POST" });
                    if (!res.ok) {
                      var error = await res.text();
                      setPopupError(error);
                      return;
                    }
                    //const url = await blobToDataURL(await res.blob());

                    var data = await res.json();
                    const media = MediaSchema.parse(data.media);
                    var indexUsed = mediaIndex;

                    if (isFirstFile)//find mediaindex
                    {
                      let found = false;
                      //loop through media files to find matching aspect ratio
                      for (var i = 0; i < (form.getValues("tbMediaFiles") ?? []).length; i++) {
                        if (form.getValues(`tbMediaFiles.${i}.aspectRatio`) == media.aspectRatio) {
                          setIndex(i);
                          indexUsed = i;
                          found = true;
                          break;
                        }
                      }
                      if (!found)//no match, add new media file
                      {
                        var error = translate("ui.nomediaforaspectratio") + media.aspectRatio;
                        setPopupError(error);
                        return;
                      }

                      setIsFirstFile(false);

if(data.warnings != "")
        setWarning(data.warnings);
                    }

                    setFileSelection(null);
                    setPopupRedlof(false);
                    setPopup(false);
                    setChanged(true);

                    form.setValue(`tbMediaFiles.${indexUsed}`, media, { shouldDirty: true, shouldTouch: true });
                    if (form.getValues("spotName") == null || form.getValues("spotName") === "") {
                      var name = file.substring(file.lastIndexOf("\\") + 1);
                      name = name.substring(0, name.lastIndexOf("."));
                      form.setValue("spotName", name, { shouldDirty: true, shouldTouch: true });
                    }
                    await setSource(media, indexUsed);
                    //form.setValue(`tbMediaFiles.${index}.fileData`, url, { shouldDirty: true, shouldTouch: true });
                    //form.setValue(`tbMediaFiles.${mediaIndex}.pathServer`, "root\\" + file as string);
                    // var type = file.toLowerCase().substring(file.lastIndexOf(".") + 1);
                    // form.setValue(`tbMediaFiles.${mediaIndex}.mimeType`, type.endsWith("mp4") || type.endsWith("wmv")? "video/" + type: "image/png");
                    // form.setValue(`templateId`, null);
                    // form.setValue("statusId", 1);
                    // setFileSelection(null);

                  } catch (e) {
                    console.error(e);
                  }




                }
                else {
                  expandedList == null ? setExpandedList([value as string]) :
                    expandedList.find(s => s == value) ? //already expanded, remove
                      setExpandedList(expandedList.filter(s => s != value)) :
                      setExpandedList([...expandedList, value as string]);
                }
              }}
            ></FolderComp>
          )
          )}


        </div>

      </Popup>







      <Popup
        isOpen={isPreview}
        onClose={() => setPreview(false)}
        title={translate("common.preview")}
        className=""

      >
        <SpotPreview onStatusChanged={(statusId: number, comment: string | null) => { updateStatus(statusId, comment) }} spotId={form.getValues("spotId") as string} statusId={statusId as number}  ></SpotPreview>
      </Popup>


      <Popup
        isOpen={popupError != ""}
        onClose={() => setPopupError("")}
        title={translate("common.invalid")}
        className="w-[400px]"

      >
        <div>{popupError}</div>
      </Popup>



    </div>

  )
}



